module.exports = __webpack_public_path__ + "static/img/header.1e20a3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header.svg
// module id = v8Uc
// module chunks = 0